import {
  Menu,
} from '@/internal';
import {calendarIsEnabled} from '@/utils/settings.js';

export default (payload = {}) => {

  const {user} = payload;

  const logs = user?.logs || [];
  const calendarEnabled = calendarIsEnabled(user);

  const logsMenuItems = [
    ...logs.sort((a, b) => a.name > b.name ? 1 : -1).map((log) => {
      return {
        icon: log.icon,
        title: log.name,
        route: {
          ...window.app.findRouteByName('log/show', [], {
            params: {
              logKey: log.key,
            },
          }),
        },
      };
    })
  ];

  return new Menu({
    title: 'Logs',
    open: true,
    menuItems: [
      ...(calendarEnabled ? [
        {
          route: window.app.findRouteByName('calendar/index'),
        },
      ] : []),
      {
        route: window.app.findRouteByName('workout/index'),
      },
      ...logsMenuItems,
    ],
  });
};
